import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.scss']
})
export class StatusChipComponent implements OnInit, OnChanges {
  @Input() status: any;
  @Input() size: 'default' | 'compact' = 'default';

  statusText: string = '';
  colorClass: string = 'status-grey';

  ngOnInit(): void {
    this.resolveStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status'] || changes['size']) {
      this.resolveStatus();
    }
  }

  private resolveStatus(): void {
    if (this.status === undefined || this.status === null) {
      this.statusText = '';
      this.colorClass = 'status-grey';
      return;
    }

    // Convert status to string
    let rawStatus = String(this.status).trim();


    const emojiRegex = /[\u2600-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDFFF]/g;
    rawStatus = rawStatus.replace(emojiRegex, '').trim();

    this.statusText = this.toTitleCase(rawStatus);

    // Clean up for mapping key
    const cleanStatus = rawStatus.toLowerCase().replace(/[^a-z0-9]/g, '');

    switch (cleanStatus) {
      // GREEN statuses: Completed, Success, Valid, Approved, Stored, Accepted, Delivered, Resolved
      case 'completed':
      case 'success':
      case 'valid':
      case 'approved':
      case 'stored':
      case 'accepted':
      case 'delivered':
      case 'resolved':
      case 'resolvebyshipper':
      case 'resolvebycarrier':
      case 'disputeresolved':
      case 'disputedresolved':
        this.colorClass = 'status-green';
        break;

      // BLUE statuses: Active, In Progress, InProgress, Started
      case 'active':
      case 'inprogress':
      case 'started':
        this.colorClass = 'status-blue';
        break;

      // GOLD/YELLOW statuses: Assigned, Warning, Pending, On Leave, On-Leave, Expiring Soon, Bid Submitted
      case 'assigned':
      case 'upcoming':
      case 'warning':
      case 'pending':
      case 'onleave':
      case 'expiringsoon':
      case 'bidsubmitted':
        this.colorClass = 'status-gold';
        break;

      // RED statuses: Cancelled, Canceled, Rejected, Declined, Expired, Disputed, Dispute, Withdraw, Withdrawn, Inactive
      case 'cancelled':
      case 'canceled':
      case 'rejected':
      case 'declined':
      case 'expired':
      case 'disputed':
      case 'dispute':
      case 'withdraw':
      case 'withdrawn':
      case 'cancelbycarrier':
      case 'cancelbyshipper':
      case 'inactive':
        this.colorClass = 'status-red';
        break;

      // GREY statuses: Open, Draft, Unassigned, Unassign, Default
      case 'open':
      case 'draft':
      case 'unassigned':
      case 'unassign':
      case 'default':
        this.colorClass = 'status-grey';
        break;

      default:
        this.colorClass = 'status-grey';
        break;
    }
  }

  private toTitleCase(value: string): string {
    return value
      .toLowerCase()
      .split(' ')
      .filter((word) => word.length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
